import {CompetitorStandingsPageRouteMetaDataModel} from "./competitor.standings-page.route.meta-data.model";
import {PAGES} from "../../../../../core/consts";
import {CompetitorPageRouteConfig} from "../../../models/competitor.page-route.config";

export class CompetitorStandingsPageRouteConfig extends CompetitorPageRouteConfig {
  static injectables = [];

  constructor() {
    super({
      name: PAGES.COMPETITOR.standings,
      path: `standings`,
      componentImport: () => import("../components/competitor.standings-page" /* webpackChunkName: "competitor.standings-page" */),
      metadataType: CompetitorStandingsPageRouteMetaDataModel
    });
  }
}